import { deleteReq } from "../../service/api";

const DeletePos = async (id) => {
  try {
    const response = await deleteReq(`/pos/${id}`);
    return response;
  } catch (error) {
    console.error("Error UpdatePos:", error);
    throw error;
  }
};

export default DeletePos;
